import { render } from "./Admin.vue?vue&type=template&id=1279a8a0&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=1279a8a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1279a8a0"],['__file',"src/layouts/Admin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1279a8a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1279a8a0', __exports__)) {
    api.reload('1279a8a0', __exports__)
  }
  
  module.hot.accept("./Admin.vue?vue&type=template&id=1279a8a0&scoped=true", () => {
    api.rerender('1279a8a0', render)
  })

}


export default __exports__